module.exports = __webpack_public_path__ + "img/icons_succes.10f9ed84.png";